import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getFetchCMS } from '~/src/queries/services/fetchCMS';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Long: { input: any; output: any; }
  Time: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AdminUser = {
  __typename?: 'AdminUser';
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type CarteMarketing = {
  __typename?: 'CarteMarketing';
  Modale_Marketing?: Maybe<ComponentMultipleFieldsModaleMarketing>;
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<ComponentImageImagePicker>;
  keplr_id: Scalars['String']['output'];
  keplr_name: Scalars['String']['output'];
  link_label?: Maybe<Scalars['String']['output']>;
  link_url?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CarteMarketingAggregator = {
  __typename?: 'CarteMarketingAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CarteMarketingConnection = {
  __typename?: 'CarteMarketingConnection';
  aggregate?: Maybe<CarteMarketingAggregator>;
  groupBy?: Maybe<CarteMarketingGroupBy>;
  values?: Maybe<Array<Maybe<CarteMarketing>>>;
};

export type CarteMarketingConnectionCreatedAt = {
  __typename?: 'CarteMarketingConnectionCreatedAt';
  connection?: Maybe<CarteMarketingConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type CarteMarketingConnectionDescription = {
  __typename?: 'CarteMarketingConnectionDescription';
  connection?: Maybe<CarteMarketingConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CarteMarketingConnectionId = {
  __typename?: 'CarteMarketingConnectionId';
  connection?: Maybe<CarteMarketingConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type CarteMarketingConnectionImage = {
  __typename?: 'CarteMarketingConnectionImage';
  connection?: Maybe<CarteMarketingConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type CarteMarketingConnectionKeplr_Id = {
  __typename?: 'CarteMarketingConnectionKeplr_id';
  connection?: Maybe<CarteMarketingConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CarteMarketingConnectionKeplr_Name = {
  __typename?: 'CarteMarketingConnectionKeplr_name';
  connection?: Maybe<CarteMarketingConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CarteMarketingConnectionLink_Label = {
  __typename?: 'CarteMarketingConnectionLink_label';
  connection?: Maybe<CarteMarketingConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CarteMarketingConnectionLink_Url = {
  __typename?: 'CarteMarketingConnectionLink_url';
  connection?: Maybe<CarteMarketingConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CarteMarketingConnectionModale_Marketing = {
  __typename?: 'CarteMarketingConnectionModale_Marketing';
  connection?: Maybe<CarteMarketingConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type CarteMarketingConnectionTitle = {
  __typename?: 'CarteMarketingConnectionTitle';
  connection?: Maybe<CarteMarketingConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CarteMarketingConnectionUpdatedAt = {
  __typename?: 'CarteMarketingConnectionUpdatedAt';
  connection?: Maybe<CarteMarketingConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type CarteMarketingConnection_Id = {
  __typename?: 'CarteMarketingConnection_id';
  connection?: Maybe<CarteMarketingConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type CarteMarketingGroupBy = {
  __typename?: 'CarteMarketingGroupBy';
  Modale_Marketing?: Maybe<Array<Maybe<CarteMarketingConnectionModale_Marketing>>>;
  _id?: Maybe<Array<Maybe<CarteMarketingConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<CarteMarketingConnectionCreatedAt>>>;
  description?: Maybe<Array<Maybe<CarteMarketingConnectionDescription>>>;
  id?: Maybe<Array<Maybe<CarteMarketingConnectionId>>>;
  image?: Maybe<Array<Maybe<CarteMarketingConnectionImage>>>;
  keplr_id?: Maybe<Array<Maybe<CarteMarketingConnectionKeplr_Id>>>;
  keplr_name?: Maybe<Array<Maybe<CarteMarketingConnectionKeplr_Name>>>;
  link_label?: Maybe<Array<Maybe<CarteMarketingConnectionLink_Label>>>;
  link_url?: Maybe<Array<Maybe<CarteMarketingConnectionLink_Url>>>;
  title?: Maybe<Array<Maybe<CarteMarketingConnectionTitle>>>;
  updatedAt?: Maybe<Array<Maybe<CarteMarketingConnectionUpdatedAt>>>;
};

export type CarteMarketingInput = {
  Modale_Marketing?: InputMaybe<ComponentMultipleFieldsModaleMarketingInput>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  image: ComponentImageImagePickerInput;
  keplr_id: Scalars['String']['input'];
  keplr_name: Scalars['String']['input'];
  link_label?: InputMaybe<Scalars['String']['input']>;
  link_url?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentImageImagePicker = {
  __typename?: 'ComponentImageImagePicker';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  keplr_id?: Maybe<Scalars['String']['output']>;
  media: Scalars['String']['output'];
};

export type ComponentImageImagePickerInput = {
  keplr_id?: InputMaybe<Scalars['String']['input']>;
  media: Scalars['String']['input'];
};

export type ComponentMultipleFieldsModaleMarketing = {
  __typename?: 'ComponentMultipleFieldsModaleMarketing';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  modale_marketing?: Maybe<ModaleMarketing>;
};

export type ComponentMultipleFieldsModaleMarketingInput = {
  modale_marketing?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMultipleFieldsOpeningAction = {
  __typename?: 'ComponentMultipleFieldsOpeningAction';
  URL_link?: Maybe<Scalars['String']['output']>;
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  modale_marketing?: Maybe<ModaleMarketing>;
};

export type ComponentMultipleFieldsOpeningActionInput = {
  URL_link?: InputMaybe<Scalars['String']['input']>;
  modale_marketing?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentTexteTexteAvecCouleur = {
  __typename?: 'ComponentTexteTexteAvecCouleur';
  Color?: Maybe<Enum_Componenttextetexteaveccouleur_Color>;
  Content?: Maybe<Scalars['String']['output']>;
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentTexteTexteAvecCouleurInput = {
  Color?: InputMaybe<Enum_Componenttextetexteaveccouleur_Color>;
  Content?: InputMaybe<Scalars['String']['input']>;
};

export enum Enum_Componenttextetexteaveccouleur_Color {
  Blanc = 'Blanc',
  Rose = 'Rose',
  Sombre = 'Sombre',
  Vert = 'Vert'
}

export enum Enum_Referral_Image_Referee_Award {
  Cadeau = 'Cadeau',
  Livraison = 'Livraison',
  Produits = 'Produits',
  Reduction = 'Reduction'
}

export enum Enum_Referral_Image_Referrer_Award {
  Cadeau = 'Cadeau',
  Livraison = 'Livraison',
  Produits = 'Produits',
  Reduction = 'Reduction'
}

export type FocusMagasin = {
  __typename?: 'FocusMagasin';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<ComponentImageImagePicker>;
  keplr_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FocusMagasinAggregator = {
  __typename?: 'FocusMagasinAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FocusMagasinConnection = {
  __typename?: 'FocusMagasinConnection';
  aggregate?: Maybe<FocusMagasinAggregator>;
  groupBy?: Maybe<FocusMagasinGroupBy>;
  values?: Maybe<Array<Maybe<FocusMagasin>>>;
};

export type FocusMagasinConnectionCreatedAt = {
  __typename?: 'FocusMagasinConnectionCreatedAt';
  connection?: Maybe<FocusMagasinConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type FocusMagasinConnectionId = {
  __typename?: 'FocusMagasinConnectionId';
  connection?: Maybe<FocusMagasinConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type FocusMagasinConnectionImage = {
  __typename?: 'FocusMagasinConnectionImage';
  connection?: Maybe<FocusMagasinConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type FocusMagasinConnectionKeplr_Id = {
  __typename?: 'FocusMagasinConnectionKeplr_id';
  connection?: Maybe<FocusMagasinConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FocusMagasinConnectionName = {
  __typename?: 'FocusMagasinConnectionName';
  connection?: Maybe<FocusMagasinConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FocusMagasinConnectionUpdatedAt = {
  __typename?: 'FocusMagasinConnectionUpdatedAt';
  connection?: Maybe<FocusMagasinConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type FocusMagasinConnection_Id = {
  __typename?: 'FocusMagasinConnection_id';
  connection?: Maybe<FocusMagasinConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type FocusMagasinGroupBy = {
  __typename?: 'FocusMagasinGroupBy';
  _id?: Maybe<Array<Maybe<FocusMagasinConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<FocusMagasinConnectionCreatedAt>>>;
  id?: Maybe<Array<Maybe<FocusMagasinConnectionId>>>;
  image?: Maybe<Array<Maybe<FocusMagasinConnectionImage>>>;
  keplr_id?: Maybe<Array<Maybe<FocusMagasinConnectionKeplr_Id>>>;
  name?: Maybe<Array<Maybe<FocusMagasinConnectionName>>>;
  updatedAt?: Maybe<Array<Maybe<FocusMagasinConnectionUpdatedAt>>>;
};

export type FocusMagasinInput = {
  created_by?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<ComponentImageImagePickerInput>;
  keplr_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type Header = {
  __typename?: 'Header';
  CTA_action?: Maybe<ComponentMultipleFieldsOpeningAction>;
  _id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  alt_text?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expiration_dates?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<ComponentImageImagePicker>;
  keplr_id: Scalars['String']['output'];
  keplr_name: Scalars['String']['output'];
  link_label?: Maybe<Scalars['String']['output']>;
  link_url?: Maybe<Scalars['String']['output']>;
  order_number?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type HeaderAggregator = {
  __typename?: 'HeaderAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type HeaderConnection = {
  __typename?: 'HeaderConnection';
  aggregate?: Maybe<HeaderAggregator>;
  groupBy?: Maybe<HeaderGroupBy>;
  values?: Maybe<Array<Maybe<Header>>>;
};

export type HeaderConnectionActive = {
  __typename?: 'HeaderConnectionActive';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['Boolean']['output']>;
};

export type HeaderConnectionAlt_Text = {
  __typename?: 'HeaderConnectionAlt_text';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type HeaderConnectionCta_Action = {
  __typename?: 'HeaderConnectionCTA_action';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type HeaderConnectionCreatedAt = {
  __typename?: 'HeaderConnectionCreatedAt';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type HeaderConnectionDescription = {
  __typename?: 'HeaderConnectionDescription';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type HeaderConnectionExpiration_Dates = {
  __typename?: 'HeaderConnectionExpiration_dates';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type HeaderConnectionId = {
  __typename?: 'HeaderConnectionId';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type HeaderConnectionImage = {
  __typename?: 'HeaderConnectionImage';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type HeaderConnectionKeplr_Id = {
  __typename?: 'HeaderConnectionKeplr_id';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type HeaderConnectionKeplr_Name = {
  __typename?: 'HeaderConnectionKeplr_name';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type HeaderConnectionLink_Label = {
  __typename?: 'HeaderConnectionLink_label';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type HeaderConnectionLink_Url = {
  __typename?: 'HeaderConnectionLink_url';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type HeaderConnectionOrder_Number = {
  __typename?: 'HeaderConnectionOrder_number';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type HeaderConnectionTitle = {
  __typename?: 'HeaderConnectionTitle';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type HeaderConnectionUpdatedAt = {
  __typename?: 'HeaderConnectionUpdatedAt';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type HeaderConnection_Id = {
  __typename?: 'HeaderConnection_id';
  connection?: Maybe<HeaderConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type HeaderGroupBy = {
  __typename?: 'HeaderGroupBy';
  CTA_action?: Maybe<Array<Maybe<HeaderConnectionCta_Action>>>;
  _id?: Maybe<Array<Maybe<HeaderConnection_Id>>>;
  active?: Maybe<Array<Maybe<HeaderConnectionActive>>>;
  alt_text?: Maybe<Array<Maybe<HeaderConnectionAlt_Text>>>;
  createdAt?: Maybe<Array<Maybe<HeaderConnectionCreatedAt>>>;
  description?: Maybe<Array<Maybe<HeaderConnectionDescription>>>;
  expiration_dates?: Maybe<Array<Maybe<HeaderConnectionExpiration_Dates>>>;
  id?: Maybe<Array<Maybe<HeaderConnectionId>>>;
  image?: Maybe<Array<Maybe<HeaderConnectionImage>>>;
  keplr_id?: Maybe<Array<Maybe<HeaderConnectionKeplr_Id>>>;
  keplr_name?: Maybe<Array<Maybe<HeaderConnectionKeplr_Name>>>;
  link_label?: Maybe<Array<Maybe<HeaderConnectionLink_Label>>>;
  link_url?: Maybe<Array<Maybe<HeaderConnectionLink_Url>>>;
  order_number?: Maybe<Array<Maybe<HeaderConnectionOrder_Number>>>;
  title?: Maybe<Array<Maybe<HeaderConnectionTitle>>>;
  updatedAt?: Maybe<Array<Maybe<HeaderConnectionUpdatedAt>>>;
};

export type HeaderInput = {
  CTA_action?: InputMaybe<ComponentMultipleFieldsOpeningActionInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  alt_text?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiration_dates?: InputMaybe<Scalars['String']['input']>;
  image: ComponentImageImagePickerInput;
  keplr_id: Scalars['String']['input'];
  keplr_name: Scalars['String']['input'];
  link_label?: InputMaybe<Scalars['String']['input']>;
  link_url?: InputMaybe<Scalars['String']['input']>;
  order_number?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type InputId = {
  id: Scalars['ID']['input'];
};

export type MainLandingPageV1 = {
  __typename?: 'MainLandingPageV1';
  _id: Scalars['ID']['output'];
  background_image_web?: Maybe<ComponentImageImagePicker>;
  background_image_web_mobile?: Maybe<ComponentImageImagePicker>;
  createdAt: Scalars['DateTime']['output'];
  experiment: Scalars['String']['output'];
  homepage_link_label: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_homepage_link_displayed: Scalars['Boolean']['output'];
  published_at?: Maybe<Scalars['DateTime']['output']>;
  shipping_field_placeholder: Scalars['String']['output'];
  subtitle_1?: Maybe<ComponentTexteTexteAvecCouleur>;
  subtitle_2?: Maybe<ComponentTexteTexteAvecCouleur>;
  subtitle_3?: Maybe<ComponentTexteTexteAvecCouleur>;
  title_1?: Maybe<ComponentTexteTexteAvecCouleur>;
  title_2?: Maybe<ComponentTexteTexteAvecCouleur>;
  title_3?: Maybe<ComponentTexteTexteAvecCouleur>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MainLandingPageV1Input = {
  background_image_web: ComponentImageImagePickerInput;
  background_image_web_mobile: ComponentImageImagePickerInput;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  experiment: Scalars['String']['input'];
  homepage_link_label: Scalars['String']['input'];
  is_homepage_link_displayed?: InputMaybe<Scalars['Boolean']['input']>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  shipping_field_placeholder: Scalars['String']['input'];
  subtitle_1?: InputMaybe<ComponentTexteTexteAvecCouleurInput>;
  subtitle_2?: InputMaybe<ComponentTexteTexteAvecCouleurInput>;
  subtitle_3?: InputMaybe<ComponentTexteTexteAvecCouleurInput>;
  title_1: ComponentTexteTexteAvecCouleurInput;
  title_2?: InputMaybe<ComponentTexteTexteAvecCouleurInput>;
  title_3?: InputMaybe<ComponentTexteTexteAvecCouleurInput>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type MainLandingPageV2 = {
  __typename?: 'MainLandingPageV2';
  _id: Scalars['ID']['output'];
  background_image_web?: Maybe<ComponentImageImagePicker>;
  background_image_web_mobile?: Maybe<ComponentImageImagePicker>;
  createdAt: Scalars['DateTime']['output'];
  experiment: Scalars['String']['output'];
  homepage_link_label: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_homepage_link_displayed: Scalars['Boolean']['output'];
  published_at?: Maybe<Scalars['DateTime']['output']>;
  shipping_field_placeholder: Scalars['String']['output'];
  subtitle_1?: Maybe<ComponentTexteTexteAvecCouleur>;
  subtitle_2?: Maybe<ComponentTexteTexteAvecCouleur>;
  subtitle_3?: Maybe<ComponentTexteTexteAvecCouleur>;
  title_1?: Maybe<ComponentTexteTexteAvecCouleur>;
  title_2?: Maybe<ComponentTexteTexteAvecCouleur>;
  title_3?: Maybe<ComponentTexteTexteAvecCouleur>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MainLandingPageV2Input = {
  background_image_web: ComponentImageImagePickerInput;
  background_image_web_mobile: ComponentImageImagePickerInput;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  experiment: Scalars['String']['input'];
  homepage_link_label: Scalars['String']['input'];
  is_homepage_link_displayed?: InputMaybe<Scalars['Boolean']['input']>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  shipping_field_placeholder: Scalars['String']['input'];
  subtitle_1?: InputMaybe<ComponentTexteTexteAvecCouleurInput>;
  subtitle_2?: InputMaybe<ComponentTexteTexteAvecCouleurInput>;
  subtitle_3?: InputMaybe<ComponentTexteTexteAvecCouleurInput>;
  title_1: ComponentTexteTexteAvecCouleurInput;
  title_2?: InputMaybe<ComponentTexteTexteAvecCouleurInput>;
  title_3?: InputMaybe<ComponentTexteTexteAvecCouleurInput>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type ModaleMarketing = {
  __typename?: 'ModaleMarketing';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<ComponentImageImagePicker>;
  info_slug: Scalars['String']['output'];
  keplr_name: Scalars['String']['output'];
  meta_description: Scalars['String']['output'];
  meta_title?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ModaleMarketingAggregator = {
  __typename?: 'ModaleMarketingAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ModaleMarketingConnection = {
  __typename?: 'ModaleMarketingConnection';
  aggregate?: Maybe<ModaleMarketingAggregator>;
  groupBy?: Maybe<ModaleMarketingGroupBy>;
  values?: Maybe<Array<Maybe<ModaleMarketing>>>;
};

export type ModaleMarketingConnectionCreatedAt = {
  __typename?: 'ModaleMarketingConnectionCreatedAt';
  connection?: Maybe<ModaleMarketingConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ModaleMarketingConnectionDescription = {
  __typename?: 'ModaleMarketingConnectionDescription';
  connection?: Maybe<ModaleMarketingConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModaleMarketingConnectionId = {
  __typename?: 'ModaleMarketingConnectionId';
  connection?: Maybe<ModaleMarketingConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ModaleMarketingConnectionImage = {
  __typename?: 'ModaleMarketingConnectionImage';
  connection?: Maybe<ModaleMarketingConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ModaleMarketingConnectionInfo_Slug = {
  __typename?: 'ModaleMarketingConnectionInfo_slug';
  connection?: Maybe<ModaleMarketingConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModaleMarketingConnectionKeplr_Name = {
  __typename?: 'ModaleMarketingConnectionKeplr_name';
  connection?: Maybe<ModaleMarketingConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModaleMarketingConnectionMeta_Description = {
  __typename?: 'ModaleMarketingConnectionMeta_description';
  connection?: Maybe<ModaleMarketingConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModaleMarketingConnectionMeta_Title = {
  __typename?: 'ModaleMarketingConnectionMeta_title';
  connection?: Maybe<ModaleMarketingConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModaleMarketingConnectionPublished_At = {
  __typename?: 'ModaleMarketingConnectionPublished_at';
  connection?: Maybe<ModaleMarketingConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ModaleMarketingConnectionTitle = {
  __typename?: 'ModaleMarketingConnectionTitle';
  connection?: Maybe<ModaleMarketingConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModaleMarketingConnectionUpdatedAt = {
  __typename?: 'ModaleMarketingConnectionUpdatedAt';
  connection?: Maybe<ModaleMarketingConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ModaleMarketingConnection_Id = {
  __typename?: 'ModaleMarketingConnection_id';
  connection?: Maybe<ModaleMarketingConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ModaleMarketingGroupBy = {
  __typename?: 'ModaleMarketingGroupBy';
  _id?: Maybe<Array<Maybe<ModaleMarketingConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<ModaleMarketingConnectionCreatedAt>>>;
  description?: Maybe<Array<Maybe<ModaleMarketingConnectionDescription>>>;
  id?: Maybe<Array<Maybe<ModaleMarketingConnectionId>>>;
  image?: Maybe<Array<Maybe<ModaleMarketingConnectionImage>>>;
  info_slug?: Maybe<Array<Maybe<ModaleMarketingConnectionInfo_Slug>>>;
  keplr_name?: Maybe<Array<Maybe<ModaleMarketingConnectionKeplr_Name>>>;
  meta_description?: Maybe<Array<Maybe<ModaleMarketingConnectionMeta_Description>>>;
  meta_title?: Maybe<Array<Maybe<ModaleMarketingConnectionMeta_Title>>>;
  published_at?: Maybe<Array<Maybe<ModaleMarketingConnectionPublished_At>>>;
  title?: Maybe<Array<Maybe<ModaleMarketingConnectionTitle>>>;
  updatedAt?: Maybe<Array<Maybe<ModaleMarketingConnectionUpdatedAt>>>;
};

export type ModaleMarketingInput = {
  created_by?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  image?: InputMaybe<ComponentImageImagePickerInput>;
  info_slug: Scalars['String']['input'];
  keplr_name: Scalars['String']['input'];
  meta_description: Scalars['String']['input'];
  meta_title?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type Morph = CarteMarketing | CarteMarketingAggregator | CarteMarketingConnection | CarteMarketingConnectionCreatedAt | CarteMarketingConnectionDescription | CarteMarketingConnectionId | CarteMarketingConnectionImage | CarteMarketingConnectionKeplr_Id | CarteMarketingConnectionKeplr_Name | CarteMarketingConnectionLink_Label | CarteMarketingConnectionLink_Url | CarteMarketingConnectionModale_Marketing | CarteMarketingConnectionTitle | CarteMarketingConnectionUpdatedAt | CarteMarketingConnection_Id | CarteMarketingGroupBy | ComponentImageImagePicker | ComponentMultipleFieldsModaleMarketing | ComponentMultipleFieldsOpeningAction | ComponentTexteTexteAvecCouleur | FocusMagasin | FocusMagasinAggregator | FocusMagasinConnection | FocusMagasinConnectionCreatedAt | FocusMagasinConnectionId | FocusMagasinConnectionImage | FocusMagasinConnectionKeplr_Id | FocusMagasinConnectionName | FocusMagasinConnectionUpdatedAt | FocusMagasinConnection_Id | FocusMagasinGroupBy | Header | HeaderAggregator | HeaderConnection | HeaderConnectionActive | HeaderConnectionAlt_Text | HeaderConnectionCta_Action | HeaderConnectionCreatedAt | HeaderConnectionDescription | HeaderConnectionExpiration_Dates | HeaderConnectionId | HeaderConnectionImage | HeaderConnectionKeplr_Id | HeaderConnectionKeplr_Name | HeaderConnectionLink_Label | HeaderConnectionLink_Url | HeaderConnectionOrder_Number | HeaderConnectionTitle | HeaderConnectionUpdatedAt | HeaderConnection_Id | HeaderGroupBy | MainLandingPageV1 | MainLandingPageV2 | ModaleMarketing | ModaleMarketingAggregator | ModaleMarketingConnection | ModaleMarketingConnectionCreatedAt | ModaleMarketingConnectionDescription | ModaleMarketingConnectionId | ModaleMarketingConnectionImage | ModaleMarketingConnectionInfo_Slug | ModaleMarketingConnectionKeplr_Name | ModaleMarketingConnectionMeta_Description | ModaleMarketingConnectionMeta_Title | ModaleMarketingConnectionPublished_At | ModaleMarketingConnectionTitle | ModaleMarketingConnectionUpdatedAt | ModaleMarketingConnection_Id | ModaleMarketingGroupBy | Referral | UserPermissionsPasswordPayload | UsersPermissionsLoginPayload | UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleAggregator | UsersPermissionsRoleConnection | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionType | UsersPermissionsRoleConnection_Id | UsersPermissionsRoleGroupBy | UsersPermissionsUser | UsersPermissionsUserAggregator | UsersPermissionsUserConnection | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionCreatedAt | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionId | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionRole | UsersPermissionsUserConnectionUpdatedAt | UsersPermissionsUserConnectionUsername | UsersPermissionsUserConnection_Id | UsersPermissionsUserGroupBy | Zone | ZoneAggregator | ZoneConnection | ZoneConnectionActivated | ZoneConnectionCreatedAt | ZoneConnectionId | ZoneConnectionKeplr_Id | ZoneConnectionName | ZoneConnectionPrivate_Info | ZoneConnectionPublic_Info | ZoneConnectionShop | ZoneConnectionType | ZoneConnectionUpdatedAt | ZoneConnection_Id | ZoneGroupBy | CreateCarteMarketingPayload | CreateFocusMagasinPayload | CreateHeaderPayload | CreateModaleMarketingPayload | CreateRolePayload | CreateUserPayload | CreateZonePayload | DeleteCarteMarketingPayload | DeleteFocusMagasinPayload | DeleteHeaderPayload | DeleteMainLandingPageV1Payload | DeleteMainLandingPageV2Payload | DeleteModaleMarketingPayload | DeleteReferralPayload | DeleteRolePayload | DeleteUserPayload | DeleteZonePayload | UpdateCarteMarketingPayload | UpdateFocusMagasinPayload | UpdateHeaderPayload | UpdateMainLandingPageV1Payload | UpdateMainLandingPageV2Payload | UpdateModaleMarketingPayload | UpdateReferralPayload | UpdateRolePayload | UpdateUserPayload | UpdateZonePayload;

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  carteMarketing?: Maybe<CarteMarketing>;
  carteMarketings?: Maybe<Array<Maybe<CarteMarketing>>>;
  carteMarketingsConnection?: Maybe<CarteMarketingConnection>;
  focusMagasin?: Maybe<FocusMagasin>;
  focusMagasins?: Maybe<Array<Maybe<FocusMagasin>>>;
  focusMagasinsConnection?: Maybe<FocusMagasinConnection>;
  header?: Maybe<Header>;
  headers?: Maybe<Array<Maybe<Header>>>;
  headersConnection?: Maybe<HeaderConnection>;
  mainLandingPageV1?: Maybe<MainLandingPageV1>;
  mainLandingPageV2?: Maybe<MainLandingPageV2>;
  me?: Maybe<UsersPermissionsMe>;
  modaleMarketing?: Maybe<ModaleMarketing>;
  modaleMarketings?: Maybe<Array<Maybe<ModaleMarketing>>>;
  modaleMarketingsConnection?: Maybe<ModaleMarketingConnection>;
  referral?: Maybe<Referral>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  zone?: Maybe<Zone>;
  zones?: Maybe<Array<Maybe<Zone>>>;
  zonesConnection?: Maybe<ZoneConnection>;
};


export type QueryCarteMarketingArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryCarteMarketingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryCarteMarketingsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryFocusMagasinArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryFocusMagasinsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryFocusMagasinsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryHeaderArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryHeadersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryHeadersConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryMainLandingPageV1Args = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryMainLandingPageV2Args = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryModaleMarketingArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryModaleMarketingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryModaleMarketingsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryReferralArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryRolesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryRolesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryUsersConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryZoneArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryZonesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryZonesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type Referral = {
  __typename?: 'Referral';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  desc_referee_1: Scalars['String']['output'];
  desc_referee_2: Scalars['String']['output'];
  desc_referrer_1: Scalars['String']['output'];
  desc_referrer_2: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image_referee_award: Enum_Referral_Image_Referee_Award;
  image_referrer_award: Enum_Referral_Image_Referrer_Award;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  share_object_mail: Scalars['String']['output'];
  share_text_mail: Scalars['String']['output'];
  title_menu_1: Scalars['String']['output'];
  title_menu_2: Scalars['String']['output'];
  title_registration_referrer_1: Scalars['String']['output'];
  title_registration_referrer_2: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ReferralInput = {
  created_by?: InputMaybe<Scalars['ID']['input']>;
  desc_referee_1: Scalars['String']['input'];
  desc_referee_2: Scalars['String']['input'];
  desc_referrer_1: Scalars['String']['input'];
  desc_referrer_2: Scalars['String']['input'];
  image_referee_award: Enum_Referral_Image_Referee_Award;
  image_referrer_award: Enum_Referral_Image_Referrer_Award;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  share_object_mail: Scalars['String']['input'];
  share_text_mail: Scalars['String']['input'];
  title_menu_1: Scalars['String']['input'];
  title_menu_2: Scalars['String']['input'];
  title_registration_referrer_1: Scalars['String']['input'];
  title_registration_referrer_2: Scalars['String']['input'];
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type RoleInput = {
  created_by?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
  username: Scalars['String']['input'];
};

export type UserPermissionsPasswordPayload = {
  __typename?: 'UserPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  _id: Scalars['ID']['output'];
  action: Scalars['String']['output'];
  controller: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  policy?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  type: Scalars['String']['output'];
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  _id: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  type?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type UsersPermissionsRoleUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type UsersPermissionsRoleAggregator = {
  __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UsersPermissionsRoleConnection = {
  __typename?: 'UsersPermissionsRoleConnection';
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
};

export type UsersPermissionsRoleConnectionDescription = {
  __typename?: 'UsersPermissionsRoleConnectionDescription';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsRoleConnectionId = {
  __typename?: 'UsersPermissionsRoleConnectionId';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleConnectionName = {
  __typename?: 'UsersPermissionsRoleConnectionName';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsRoleConnectionType = {
  __typename?: 'UsersPermissionsRoleConnectionType';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsRoleConnection_Id = {
  __typename?: 'UsersPermissionsRoleConnection_id';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleGroupBy = {
  __typename?: 'UsersPermissionsRoleGroupBy';
  _id?: Maybe<Array<Maybe<UsersPermissionsRoleConnection_Id>>>;
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  _id: Scalars['ID']['output'];
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserAggregator = {
  __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UsersPermissionsUserConnection = {
  __typename?: 'UsersPermissionsUserConnection';
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};

export type UsersPermissionsUserConnectionBlocked = {
  __typename?: 'UsersPermissionsUserConnectionBlocked';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['Boolean']['output']>;
};

export type UsersPermissionsUserConnectionConfirmed = {
  __typename?: 'UsersPermissionsUserConnectionConfirmed';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['Boolean']['output']>;
};

export type UsersPermissionsUserConnectionCreatedAt = {
  __typename?: 'UsersPermissionsUserConnectionCreatedAt';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsUserConnectionEmail = {
  __typename?: 'UsersPermissionsUserConnectionEmail';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsUserConnectionId = {
  __typename?: 'UsersPermissionsUserConnectionId';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserConnectionProvider = {
  __typename?: 'UsersPermissionsUserConnectionProvider';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsUserConnectionRole = {
  __typename?: 'UsersPermissionsUserConnectionRole';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserConnectionUpdatedAt = {
  __typename?: 'UsersPermissionsUserConnectionUpdatedAt';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsUserConnectionUsername = {
  __typename?: 'UsersPermissionsUserConnectionUsername';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsUserConnection_Id = {
  __typename?: 'UsersPermissionsUserConnection_id';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserGroupBy = {
  __typename?: 'UsersPermissionsUserGroupBy';
  _id?: Maybe<Array<Maybe<UsersPermissionsUserConnection_Id>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  createdAt?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreatedAt>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
  updatedAt?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdatedAt>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
};

export type Zone = {
  __typename?: 'Zone';
  _id: Scalars['ID']['output'];
  activated?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  keplr_id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  private_info: Scalars['String']['output'];
  public_info: Scalars['String']['output'];
  shop?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ZoneAggregator = {
  __typename?: 'ZoneAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ZoneConnection = {
  __typename?: 'ZoneConnection';
  aggregate?: Maybe<ZoneAggregator>;
  groupBy?: Maybe<ZoneGroupBy>;
  values?: Maybe<Array<Maybe<Zone>>>;
};

export type ZoneConnectionActivated = {
  __typename?: 'ZoneConnectionActivated';
  connection?: Maybe<ZoneConnection>;
  key?: Maybe<Scalars['Boolean']['output']>;
};

export type ZoneConnectionCreatedAt = {
  __typename?: 'ZoneConnectionCreatedAt';
  connection?: Maybe<ZoneConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ZoneConnectionId = {
  __typename?: 'ZoneConnectionId';
  connection?: Maybe<ZoneConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ZoneConnectionKeplr_Id = {
  __typename?: 'ZoneConnectionKeplr_id';
  connection?: Maybe<ZoneConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ZoneConnectionName = {
  __typename?: 'ZoneConnectionName';
  connection?: Maybe<ZoneConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ZoneConnectionPrivate_Info = {
  __typename?: 'ZoneConnectionPrivate_info';
  connection?: Maybe<ZoneConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ZoneConnectionPublic_Info = {
  __typename?: 'ZoneConnectionPublic_info';
  connection?: Maybe<ZoneConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ZoneConnectionShop = {
  __typename?: 'ZoneConnectionShop';
  connection?: Maybe<ZoneConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ZoneConnectionType = {
  __typename?: 'ZoneConnectionType';
  connection?: Maybe<ZoneConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ZoneConnectionUpdatedAt = {
  __typename?: 'ZoneConnectionUpdatedAt';
  connection?: Maybe<ZoneConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ZoneConnection_Id = {
  __typename?: 'ZoneConnection_id';
  connection?: Maybe<ZoneConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ZoneGroupBy = {
  __typename?: 'ZoneGroupBy';
  _id?: Maybe<Array<Maybe<ZoneConnection_Id>>>;
  activated?: Maybe<Array<Maybe<ZoneConnectionActivated>>>;
  createdAt?: Maybe<Array<Maybe<ZoneConnectionCreatedAt>>>;
  id?: Maybe<Array<Maybe<ZoneConnectionId>>>;
  keplr_id?: Maybe<Array<Maybe<ZoneConnectionKeplr_Id>>>;
  name?: Maybe<Array<Maybe<ZoneConnectionName>>>;
  private_info?: Maybe<Array<Maybe<ZoneConnectionPrivate_Info>>>;
  public_info?: Maybe<Array<Maybe<ZoneConnectionPublic_Info>>>;
  shop?: Maybe<Array<Maybe<ZoneConnectionShop>>>;
  type?: Maybe<Array<Maybe<ZoneConnectionType>>>;
  updatedAt?: Maybe<Array<Maybe<ZoneConnectionUpdatedAt>>>;
};

export type ZoneInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  keplr_id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  private_info: Scalars['String']['input'];
  public_info: Scalars['String']['input'];
  shop?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCarteMarketingInput = {
  data?: InputMaybe<CarteMarketingInput>;
};

export type CreateCarteMarketingPayload = {
  __typename?: 'createCarteMarketingPayload';
  carteMarketing?: Maybe<CarteMarketing>;
};

export type CreateFocusMagasinInput = {
  data?: InputMaybe<FocusMagasinInput>;
};

export type CreateFocusMagasinPayload = {
  __typename?: 'createFocusMagasinPayload';
  focusMagasin?: Maybe<FocusMagasin>;
};

export type CreateHeaderInput = {
  data?: InputMaybe<HeaderInput>;
};

export type CreateHeaderPayload = {
  __typename?: 'createHeaderPayload';
  header?: Maybe<Header>;
};

export type CreateModaleMarketingInput = {
  data?: InputMaybe<ModaleMarketingInput>;
};

export type CreateModaleMarketingPayload = {
  __typename?: 'createModaleMarketingPayload';
  modaleMarketing?: Maybe<ModaleMarketing>;
};

export type CreateRoleInput = {
  data?: InputMaybe<RoleInput>;
};

export type CreateRolePayload = {
  __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type CreateUserInput = {
  data?: InputMaybe<UserInput>;
};

export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type CreateZoneInput = {
  data?: InputMaybe<ZoneInput>;
};

export type CreateZonePayload = {
  __typename?: 'createZonePayload';
  zone?: Maybe<Zone>;
};

export type DeleteCarteMarketingInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteCarteMarketingPayload = {
  __typename?: 'deleteCarteMarketingPayload';
  carteMarketing?: Maybe<CarteMarketing>;
};

export type DeleteFocusMagasinInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteFocusMagasinPayload = {
  __typename?: 'deleteFocusMagasinPayload';
  focusMagasin?: Maybe<FocusMagasin>;
};

export type DeleteHeaderInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteHeaderPayload = {
  __typename?: 'deleteHeaderPayload';
  header?: Maybe<Header>;
};

export type DeleteMainLandingPageV1Payload = {
  __typename?: 'deleteMainLandingPageV1Payload';
  mainLandingPageV1?: Maybe<MainLandingPageV1>;
};

export type DeleteMainLandingPageV2Payload = {
  __typename?: 'deleteMainLandingPageV2Payload';
  mainLandingPageV2?: Maybe<MainLandingPageV2>;
};

export type DeleteModaleMarketingInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteModaleMarketingPayload = {
  __typename?: 'deleteModaleMarketingPayload';
  modaleMarketing?: Maybe<ModaleMarketing>;
};

export type DeleteReferralPayload = {
  __typename?: 'deleteReferralPayload';
  referral?: Maybe<Referral>;
};

export type DeleteRoleInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteRolePayload = {
  __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteUserInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteZoneInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteZonePayload = {
  __typename?: 'deleteZonePayload';
  zone?: Maybe<Zone>;
};

export type EditCarteMarketingInput = {
  Modale_Marketing?: InputMaybe<EditComponentMultipleFieldsModaleMarketingInput>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<EditComponentImageImagePickerInput>;
  keplr_id?: InputMaybe<Scalars['String']['input']>;
  keplr_name?: InputMaybe<Scalars['String']['input']>;
  link_label?: InputMaybe<Scalars['String']['input']>;
  link_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentImageImagePickerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  keplr_id?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Scalars['String']['input']>;
};

export type EditComponentMultipleFieldsModaleMarketingInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  modale_marketing?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentMultipleFieldsOpeningActionInput = {
  URL_link?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  modale_marketing?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentTexteTexteAvecCouleurInput = {
  Color?: InputMaybe<Enum_Componenttextetexteaveccouleur_Color>;
  Content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditFocusMagasinInput = {
  created_by?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<EditComponentImageImagePickerInput>;
  keplr_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditHeaderInput = {
  CTA_action?: InputMaybe<EditComponentMultipleFieldsOpeningActionInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  alt_text?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiration_dates?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<EditComponentImageImagePickerInput>;
  keplr_id?: InputMaybe<Scalars['String']['input']>;
  keplr_name?: InputMaybe<Scalars['String']['input']>;
  link_label?: InputMaybe<Scalars['String']['input']>;
  link_url?: InputMaybe<Scalars['String']['input']>;
  order_number?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditMainLandingPageV1Input = {
  background_image_web?: InputMaybe<EditComponentImageImagePickerInput>;
  background_image_web_mobile?: InputMaybe<EditComponentImageImagePickerInput>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  experiment?: InputMaybe<Scalars['String']['input']>;
  homepage_link_label?: InputMaybe<Scalars['String']['input']>;
  is_homepage_link_displayed?: InputMaybe<Scalars['Boolean']['input']>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  shipping_field_placeholder?: InputMaybe<Scalars['String']['input']>;
  subtitle_1?: InputMaybe<EditComponentTexteTexteAvecCouleurInput>;
  subtitle_2?: InputMaybe<EditComponentTexteTexteAvecCouleurInput>;
  subtitle_3?: InputMaybe<EditComponentTexteTexteAvecCouleurInput>;
  title_1?: InputMaybe<EditComponentTexteTexteAvecCouleurInput>;
  title_2?: InputMaybe<EditComponentTexteTexteAvecCouleurInput>;
  title_3?: InputMaybe<EditComponentTexteTexteAvecCouleurInput>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditMainLandingPageV2Input = {
  background_image_web?: InputMaybe<EditComponentImageImagePickerInput>;
  background_image_web_mobile?: InputMaybe<EditComponentImageImagePickerInput>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  experiment?: InputMaybe<Scalars['String']['input']>;
  homepage_link_label?: InputMaybe<Scalars['String']['input']>;
  is_homepage_link_displayed?: InputMaybe<Scalars['Boolean']['input']>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  shipping_field_placeholder?: InputMaybe<Scalars['String']['input']>;
  subtitle_1?: InputMaybe<EditComponentTexteTexteAvecCouleurInput>;
  subtitle_2?: InputMaybe<EditComponentTexteTexteAvecCouleurInput>;
  subtitle_3?: InputMaybe<EditComponentTexteTexteAvecCouleurInput>;
  title_1?: InputMaybe<EditComponentTexteTexteAvecCouleurInput>;
  title_2?: InputMaybe<EditComponentTexteTexteAvecCouleurInput>;
  title_3?: InputMaybe<EditComponentTexteTexteAvecCouleurInput>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditModaleMarketingInput = {
  created_by?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<EditComponentImageImagePickerInput>;
  info_slug?: InputMaybe<Scalars['String']['input']>;
  keplr_name?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditReferralInput = {
  created_by?: InputMaybe<Scalars['ID']['input']>;
  desc_referee_1?: InputMaybe<Scalars['String']['input']>;
  desc_referee_2?: InputMaybe<Scalars['String']['input']>;
  desc_referrer_1?: InputMaybe<Scalars['String']['input']>;
  desc_referrer_2?: InputMaybe<Scalars['String']['input']>;
  image_referee_award?: InputMaybe<Enum_Referral_Image_Referee_Award>;
  image_referrer_award?: InputMaybe<Enum_Referral_Image_Referrer_Award>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  share_object_mail?: InputMaybe<Scalars['String']['input']>;
  share_text_mail?: InputMaybe<Scalars['String']['input']>;
  title_menu_1?: InputMaybe<Scalars['String']['input']>;
  title_menu_2?: InputMaybe<Scalars['String']['input']>;
  title_registration_referrer_1?: InputMaybe<Scalars['String']['input']>;
  title_registration_referrer_2?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditRoleInput = {
  created_by?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type EditUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type EditZoneInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  keplr_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  private_info?: InputMaybe<Scalars['String']['input']>;
  public_info?: InputMaybe<Scalars['String']['input']>;
  shop?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCarteMarketingInput = {
  data?: InputMaybe<EditCarteMarketingInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateCarteMarketingPayload = {
  __typename?: 'updateCarteMarketingPayload';
  carteMarketing?: Maybe<CarteMarketing>;
};

export type UpdateFocusMagasinInput = {
  data?: InputMaybe<EditFocusMagasinInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateFocusMagasinPayload = {
  __typename?: 'updateFocusMagasinPayload';
  focusMagasin?: Maybe<FocusMagasin>;
};

export type UpdateHeaderInput = {
  data?: InputMaybe<EditHeaderInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateHeaderPayload = {
  __typename?: 'updateHeaderPayload';
  header?: Maybe<Header>;
};

export type UpdateMainLandingPageV1Input = {
  data?: InputMaybe<EditMainLandingPageV1Input>;
};

export type UpdateMainLandingPageV1Payload = {
  __typename?: 'updateMainLandingPageV1Payload';
  mainLandingPageV1?: Maybe<MainLandingPageV1>;
};

export type UpdateMainLandingPageV2Input = {
  data?: InputMaybe<EditMainLandingPageV2Input>;
};

export type UpdateMainLandingPageV2Payload = {
  __typename?: 'updateMainLandingPageV2Payload';
  mainLandingPageV2?: Maybe<MainLandingPageV2>;
};

export type UpdateModaleMarketingInput = {
  data?: InputMaybe<EditModaleMarketingInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateModaleMarketingPayload = {
  __typename?: 'updateModaleMarketingPayload';
  modaleMarketing?: Maybe<ModaleMarketing>;
};

export type UpdateReferralInput = {
  data?: InputMaybe<EditReferralInput>;
};

export type UpdateReferralPayload = {
  __typename?: 'updateReferralPayload';
  referral?: Maybe<Referral>;
};

export type UpdateRoleInput = {
  data?: InputMaybe<EditRoleInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateRolePayload = {
  __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateUserInput = {
  data?: InputMaybe<EditUserInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type UpdateZoneInput = {
  data?: InputMaybe<EditZoneInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateZonePayload = {
  __typename?: 'updateZonePayload';
  zone?: Maybe<Zone>;
};

export type GetMarketingCardQueryVariables = Exact<{
  card_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetMarketingCardQuery = { __typename?: 'Query', carteMarketings?: Array<{ __typename?: 'CarteMarketing', id: string, title: string, description: string, link_url?: string | null, link_label?: string | null, keplr_id: string, keplr_name: string, image?: { __typename?: 'ComponentImageImagePicker', media: string } | null, Modale_Marketing?: { __typename?: 'ComponentMultipleFieldsModaleMarketing', modale_marketing?: { __typename?: 'ModaleMarketing', info_slug: string, title: string } | null } | null } | null> | null };

export type GetFocusMagasinQueryVariables = Exact<{
  keplr_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetFocusMagasinQuery = { __typename?: 'Query', focusMagasins?: Array<{ __typename?: 'FocusMagasin', name?: string | null, keplr_id?: string | null, image?: { __typename?: 'ComponentImageImagePicker', media: string } | null } | null> | null };

export type GetHeadersQueryVariables = Exact<{
  headers_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetHeadersQuery = { __typename?: 'Query', headers?: Array<{ __typename?: 'Header', id: string, alt_text?: string | null, description?: string | null, link_url?: string | null, link_label?: string | null, keplr_id: string, keplr_name: string, image?: { __typename?: 'ComponentImageImagePicker', media: string } | null, CTA_action?: { __typename?: 'ComponentMultipleFieldsOpeningAction', id: string, URL_link?: string | null, modale_marketing?: { __typename?: 'ModaleMarketing', info_slug: string, keplr_name: string } | null } | null } | null> | null };

export type GetLandingPagesExperimentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLandingPagesExperimentsQuery = { __typename?: 'Query', mainLandingPageV1?: { __typename?: 'MainLandingPageV1', experiment: string } | null, mainLandingPageV2?: { __typename?: 'MainLandingPageV2', experiment: string } | null };

export type GetMainLandingPageV1QueryVariables = Exact<{ [key: string]: never; }>;


export type GetMainLandingPageV1Query = { __typename?: 'Query', mainLandingPageV1?: { __typename?: 'MainLandingPageV1', id: string, experiment: string, homepage_link_label: string, shipping_field_placeholder: string, is_homepage_link_displayed: boolean, background_image_web?: { __typename?: 'ComponentImageImagePicker', media: string } | null, background_image_web_mobile?: { __typename?: 'ComponentImageImagePicker', media: string } | null, title_1?: { __typename?: 'ComponentTexteTexteAvecCouleur', Content?: string | null, Color?: Enum_Componenttextetexteaveccouleur_Color | null } | null, title_2?: { __typename?: 'ComponentTexteTexteAvecCouleur', Content?: string | null, Color?: Enum_Componenttextetexteaveccouleur_Color | null } | null, title_3?: { __typename?: 'ComponentTexteTexteAvecCouleur', Content?: string | null, Color?: Enum_Componenttextetexteaveccouleur_Color | null } | null, subtitle_1?: { __typename?: 'ComponentTexteTexteAvecCouleur', Content?: string | null, Color?: Enum_Componenttextetexteaveccouleur_Color | null } | null, subtitle_2?: { __typename?: 'ComponentTexteTexteAvecCouleur', Content?: string | null, Color?: Enum_Componenttextetexteaveccouleur_Color | null } | null, subtitle_3?: { __typename?: 'ComponentTexteTexteAvecCouleur', Content?: string | null, Color?: Enum_Componenttextetexteaveccouleur_Color | null } | null } | null };

export type GetMainLandingPageV2QueryVariables = Exact<{ [key: string]: never; }>;


export type GetMainLandingPageV2Query = { __typename?: 'Query', mainLandingPageV2?: { __typename?: 'MainLandingPageV2', id: string, experiment: string, homepage_link_label: string, shipping_field_placeholder: string, is_homepage_link_displayed: boolean, background_image_web?: { __typename?: 'ComponentImageImagePicker', media: string } | null, background_image_web_mobile?: { __typename?: 'ComponentImageImagePicker', media: string } | null, title_1?: { __typename?: 'ComponentTexteTexteAvecCouleur', Content?: string | null, Color?: Enum_Componenttextetexteaveccouleur_Color | null } | null, title_2?: { __typename?: 'ComponentTexteTexteAvecCouleur', Content?: string | null, Color?: Enum_Componenttextetexteaveccouleur_Color | null } | null, title_3?: { __typename?: 'ComponentTexteTexteAvecCouleur', Content?: string | null, Color?: Enum_Componenttextetexteaveccouleur_Color | null } | null, subtitle_1?: { __typename?: 'ComponentTexteTexteAvecCouleur', Content?: string | null, Color?: Enum_Componenttextetexteaveccouleur_Color | null } | null, subtitle_2?: { __typename?: 'ComponentTexteTexteAvecCouleur', Content?: string | null, Color?: Enum_Componenttextetexteaveccouleur_Color | null } | null, subtitle_3?: { __typename?: 'ComponentTexteTexteAvecCouleur', Content?: string | null, Color?: Enum_Componenttextetexteaveccouleur_Color | null } | null } | null };

export type GetMarketingBySlugQueryVariables = Exact<{
  info_slug: Scalars['String']['input'];
}>;


export type GetMarketingBySlugQuery = { __typename?: 'Query', modaleMarketings?: Array<{ __typename?: 'ModaleMarketing', id: string, title: string, meta_title?: string | null, description: string, keplr_name: string, info_slug: string, meta_description: string, image?: { __typename?: 'ComponentImageImagePicker', media: string } | null } | null> | null };

export type GetMarketingsSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketingsSlugsQuery = { __typename?: 'Query', modaleMarketings?: Array<{ __typename?: 'ModaleMarketing', info_slug: string } | null> | null };

export type GetReferralQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReferralQuery = { __typename?: 'Query', referral?: { __typename?: 'Referral', id: string, image_referrer_award: Enum_Referral_Image_Referrer_Award, image_referee_award: Enum_Referral_Image_Referee_Award, desc_referrer_1: string, desc_referee_1: string, desc_referrer_2: string, desc_referee_2: string, title_menu_1: string, title_menu_2: string, title_registration_referrer_1: string, title_registration_referrer_2: string, share_object_mail: string, share_text_mail: string } | null };

export type GetZonesInstructionsQueryVariables = Exact<{
  keplr_ids: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type GetZonesInstructionsQuery = { __typename?: 'Query', zones?: Array<{ __typename?: 'Zone', id: string, public_info: string, private_info: string, keplr_id?: string | null } | null> | null };


export const GetMarketingCardDocument = `
    query GetMarketingCard($card_id: ID) {
  carteMarketings(where: {keplr_id: $card_id}) {
    id
    title
    description
    link_url
    link_label
    keplr_id
    keplr_name
    image {
      media
    }
    Modale_Marketing {
      modale_marketing {
        info_slug
        title
      }
    }
  }
}
    `;
export const useGetMarketingCardQuery = <
      TData = GetMarketingCardQuery,
      TError = unknown
    >(
      variables?: GetMarketingCardQueryVariables,
      options?: UseQueryOptions<GetMarketingCardQuery, TError, TData>
    ) =>
    useQuery<GetMarketingCardQuery, TError, TData>(
      variables === undefined ? ['GetMarketingCard'] : ['GetMarketingCard', variables],
      getFetchCMS<GetMarketingCardQuery, GetMarketingCardQueryVariables>(GetMarketingCardDocument, variables),
      options
    );

useGetMarketingCardQuery.getKey = (variables?: GetMarketingCardQueryVariables) => variables === undefined ? ['GetMarketingCard'] : ['GetMarketingCard', variables];
;

useGetMarketingCardQuery.fetcher = (variables?: GetMarketingCardQueryVariables, options?: RequestInit['headers']) => getFetchCMS<GetMarketingCardQuery, GetMarketingCardQueryVariables>(GetMarketingCardDocument, variables, options);
export const GetFocusMagasinDocument = `
    query GetFocusMagasin($keplr_id: ID) {
  focusMagasins(where: {keplr_id: $keplr_id}) {
    name
    keplr_id
    image {
      media
    }
  }
}
    `;
export const useGetFocusMagasinQuery = <
      TData = GetFocusMagasinQuery,
      TError = unknown
    >(
      variables?: GetFocusMagasinQueryVariables,
      options?: UseQueryOptions<GetFocusMagasinQuery, TError, TData>
    ) =>
    useQuery<GetFocusMagasinQuery, TError, TData>(
      variables === undefined ? ['GetFocusMagasin'] : ['GetFocusMagasin', variables],
      getFetchCMS<GetFocusMagasinQuery, GetFocusMagasinQueryVariables>(GetFocusMagasinDocument, variables),
      options
    );

useGetFocusMagasinQuery.getKey = (variables?: GetFocusMagasinQueryVariables) => variables === undefined ? ['GetFocusMagasin'] : ['GetFocusMagasin', variables];
;

useGetFocusMagasinQuery.fetcher = (variables?: GetFocusMagasinQueryVariables, options?: RequestInit['headers']) => getFetchCMS<GetFocusMagasinQuery, GetFocusMagasinQueryVariables>(GetFocusMagasinDocument, variables, options);
export const GetHeadersDocument = `
    query GetHeaders($headers_list: [String]) {
  headers(where: {keplr_id_in: $headers_list}) {
    id
    alt_text
    description
    link_url
    link_label
    keplr_id
    keplr_name
    image {
      media
    }
    CTA_action {
      id
      URL_link
      modale_marketing {
        info_slug
        keplr_name
      }
    }
  }
}
    `;
export const useGetHeadersQuery = <
      TData = GetHeadersQuery,
      TError = unknown
    >(
      variables?: GetHeadersQueryVariables,
      options?: UseQueryOptions<GetHeadersQuery, TError, TData>
    ) =>
    useQuery<GetHeadersQuery, TError, TData>(
      variables === undefined ? ['GetHeaders'] : ['GetHeaders', variables],
      getFetchCMS<GetHeadersQuery, GetHeadersQueryVariables>(GetHeadersDocument, variables),
      options
    );

useGetHeadersQuery.getKey = (variables?: GetHeadersQueryVariables) => variables === undefined ? ['GetHeaders'] : ['GetHeaders', variables];
;

useGetHeadersQuery.fetcher = (variables?: GetHeadersQueryVariables, options?: RequestInit['headers']) => getFetchCMS<GetHeadersQuery, GetHeadersQueryVariables>(GetHeadersDocument, variables, options);
export const GetLandingPagesExperimentsDocument = `
    query GetLandingPagesExperiments {
  mainLandingPageV1 {
    experiment
  }
  mainLandingPageV2 {
    experiment
  }
}
    `;
export const useGetLandingPagesExperimentsQuery = <
      TData = GetLandingPagesExperimentsQuery,
      TError = unknown
    >(
      variables?: GetLandingPagesExperimentsQueryVariables,
      options?: UseQueryOptions<GetLandingPagesExperimentsQuery, TError, TData>
    ) =>
    useQuery<GetLandingPagesExperimentsQuery, TError, TData>(
      variables === undefined ? ['GetLandingPagesExperiments'] : ['GetLandingPagesExperiments', variables],
      getFetchCMS<GetLandingPagesExperimentsQuery, GetLandingPagesExperimentsQueryVariables>(GetLandingPagesExperimentsDocument, variables),
      options
    );

useGetLandingPagesExperimentsQuery.getKey = (variables?: GetLandingPagesExperimentsQueryVariables) => variables === undefined ? ['GetLandingPagesExperiments'] : ['GetLandingPagesExperiments', variables];
;

useGetLandingPagesExperimentsQuery.fetcher = (variables?: GetLandingPagesExperimentsQueryVariables, options?: RequestInit['headers']) => getFetchCMS<GetLandingPagesExperimentsQuery, GetLandingPagesExperimentsQueryVariables>(GetLandingPagesExperimentsDocument, variables, options);
export const GetMainLandingPageV1Document = `
    query GetMainLandingPageV1 {
  mainLandingPageV1 {
    id
    background_image_web {
      media
    }
    background_image_web_mobile {
      media
    }
    experiment
    title_1 {
      Content
      Color
    }
    title_2 {
      Content
      Color
    }
    title_3 {
      Content
      Color
    }
    subtitle_1 {
      Content
      Color
    }
    subtitle_2 {
      Content
      Color
    }
    subtitle_3 {
      Content
      Color
    }
    homepage_link_label
    shipping_field_placeholder
    is_homepage_link_displayed
  }
}
    `;
export const useGetMainLandingPageV1Query = <
      TData = GetMainLandingPageV1Query,
      TError = unknown
    >(
      variables?: GetMainLandingPageV1QueryVariables,
      options?: UseQueryOptions<GetMainLandingPageV1Query, TError, TData>
    ) =>
    useQuery<GetMainLandingPageV1Query, TError, TData>(
      variables === undefined ? ['GetMainLandingPageV1'] : ['GetMainLandingPageV1', variables],
      getFetchCMS<GetMainLandingPageV1Query, GetMainLandingPageV1QueryVariables>(GetMainLandingPageV1Document, variables),
      options
    );

useGetMainLandingPageV1Query.getKey = (variables?: GetMainLandingPageV1QueryVariables) => variables === undefined ? ['GetMainLandingPageV1'] : ['GetMainLandingPageV1', variables];
;

useGetMainLandingPageV1Query.fetcher = (variables?: GetMainLandingPageV1QueryVariables, options?: RequestInit['headers']) => getFetchCMS<GetMainLandingPageV1Query, GetMainLandingPageV1QueryVariables>(GetMainLandingPageV1Document, variables, options);
export const GetMainLandingPageV2Document = `
    query GetMainLandingPageV2 {
  mainLandingPageV2 {
    id
    background_image_web {
      media
    }
    background_image_web_mobile {
      media
    }
    experiment
    title_1 {
      Content
      Color
    }
    title_2 {
      Content
      Color
    }
    title_3 {
      Content
      Color
    }
    subtitle_1 {
      Content
      Color
    }
    subtitle_2 {
      Content
      Color
    }
    subtitle_3 {
      Content
      Color
    }
    homepage_link_label
    shipping_field_placeholder
    is_homepage_link_displayed
  }
}
    `;
export const useGetMainLandingPageV2Query = <
      TData = GetMainLandingPageV2Query,
      TError = unknown
    >(
      variables?: GetMainLandingPageV2QueryVariables,
      options?: UseQueryOptions<GetMainLandingPageV2Query, TError, TData>
    ) =>
    useQuery<GetMainLandingPageV2Query, TError, TData>(
      variables === undefined ? ['GetMainLandingPageV2'] : ['GetMainLandingPageV2', variables],
      getFetchCMS<GetMainLandingPageV2Query, GetMainLandingPageV2QueryVariables>(GetMainLandingPageV2Document, variables),
      options
    );

useGetMainLandingPageV2Query.getKey = (variables?: GetMainLandingPageV2QueryVariables) => variables === undefined ? ['GetMainLandingPageV2'] : ['GetMainLandingPageV2', variables];
;

useGetMainLandingPageV2Query.fetcher = (variables?: GetMainLandingPageV2QueryVariables, options?: RequestInit['headers']) => getFetchCMS<GetMainLandingPageV2Query, GetMainLandingPageV2QueryVariables>(GetMainLandingPageV2Document, variables, options);
export const GetMarketingBySlugDocument = `
    query GetMarketingBySlug($info_slug: String!) {
  modaleMarketings(where: {info_slug: $info_slug}) {
    id
    title
    meta_title
    description
    keplr_name
    info_slug
    meta_description
    image {
      media
    }
  }
}
    `;
export const useGetMarketingBySlugQuery = <
      TData = GetMarketingBySlugQuery,
      TError = unknown
    >(
      variables: GetMarketingBySlugQueryVariables,
      options?: UseQueryOptions<GetMarketingBySlugQuery, TError, TData>
    ) =>
    useQuery<GetMarketingBySlugQuery, TError, TData>(
      ['GetMarketingBySlug', variables],
      getFetchCMS<GetMarketingBySlugQuery, GetMarketingBySlugQueryVariables>(GetMarketingBySlugDocument, variables),
      options
    );

useGetMarketingBySlugQuery.getKey = (variables: GetMarketingBySlugQueryVariables) => ['GetMarketingBySlug', variables];
;

useGetMarketingBySlugQuery.fetcher = (variables: GetMarketingBySlugQueryVariables, options?: RequestInit['headers']) => getFetchCMS<GetMarketingBySlugQuery, GetMarketingBySlugQueryVariables>(GetMarketingBySlugDocument, variables, options);
export const GetMarketingsSlugsDocument = `
    query GetMarketingsSlugs {
  modaleMarketings {
    info_slug
  }
}
    `;
export const useGetMarketingsSlugsQuery = <
      TData = GetMarketingsSlugsQuery,
      TError = unknown
    >(
      variables?: GetMarketingsSlugsQueryVariables,
      options?: UseQueryOptions<GetMarketingsSlugsQuery, TError, TData>
    ) =>
    useQuery<GetMarketingsSlugsQuery, TError, TData>(
      variables === undefined ? ['GetMarketingsSlugs'] : ['GetMarketingsSlugs', variables],
      getFetchCMS<GetMarketingsSlugsQuery, GetMarketingsSlugsQueryVariables>(GetMarketingsSlugsDocument, variables),
      options
    );

useGetMarketingsSlugsQuery.getKey = (variables?: GetMarketingsSlugsQueryVariables) => variables === undefined ? ['GetMarketingsSlugs'] : ['GetMarketingsSlugs', variables];
;

useGetMarketingsSlugsQuery.fetcher = (variables?: GetMarketingsSlugsQueryVariables, options?: RequestInit['headers']) => getFetchCMS<GetMarketingsSlugsQuery, GetMarketingsSlugsQueryVariables>(GetMarketingsSlugsDocument, variables, options);
export const GetReferralDocument = `
    query GetReferral {
  referral {
    id
    image_referrer_award
    image_referee_award
    desc_referrer_1
    desc_referee_1
    desc_referrer_2
    desc_referee_2
    title_menu_1
    title_menu_2
    title_registration_referrer_1
    title_registration_referrer_2
    share_object_mail
    share_text_mail
  }
}
    `;
export const useGetReferralQuery = <
      TData = GetReferralQuery,
      TError = unknown
    >(
      variables?: GetReferralQueryVariables,
      options?: UseQueryOptions<GetReferralQuery, TError, TData>
    ) =>
    useQuery<GetReferralQuery, TError, TData>(
      variables === undefined ? ['GetReferral'] : ['GetReferral', variables],
      getFetchCMS<GetReferralQuery, GetReferralQueryVariables>(GetReferralDocument, variables),
      options
    );

useGetReferralQuery.getKey = (variables?: GetReferralQueryVariables) => variables === undefined ? ['GetReferral'] : ['GetReferral', variables];
;

useGetReferralQuery.fetcher = (variables?: GetReferralQueryVariables, options?: RequestInit['headers']) => getFetchCMS<GetReferralQuery, GetReferralQueryVariables>(GetReferralDocument, variables, options);
export const GetZonesInstructionsDocument = `
    query getZonesInstructions($keplr_ids: [String]!) {
  zones(where: {keplr_id: $keplr_ids}) {
    id
    public_info
    private_info
    keplr_id
  }
}
    `;
export const useGetZonesInstructionsQuery = <
      TData = GetZonesInstructionsQuery,
      TError = unknown
    >(
      variables: GetZonesInstructionsQueryVariables,
      options?: UseQueryOptions<GetZonesInstructionsQuery, TError, TData>
    ) =>
    useQuery<GetZonesInstructionsQuery, TError, TData>(
      ['getZonesInstructions', variables],
      getFetchCMS<GetZonesInstructionsQuery, GetZonesInstructionsQueryVariables>(GetZonesInstructionsDocument, variables),
      options
    );

useGetZonesInstructionsQuery.getKey = (variables: GetZonesInstructionsQueryVariables) => ['getZonesInstructions', variables];
;

useGetZonesInstructionsQuery.fetcher = (variables: GetZonesInstructionsQueryVariables, options?: RequestInit['headers']) => getFetchCMS<GetZonesInstructionsQuery, GetZonesInstructionsQueryVariables>(GetZonesInstructionsDocument, variables, options);